import { Card, Stack, styled } from '@mui/material';
import { VssPlan, VssPublicAccount } from '@portal-middleware/hooks';
import { ProgressChart } from '@vestwell-frontend/ui';

import { FC } from 'react';

import { useGiftStateContext } from '../contexts/GiftStateContext';
import { GiftInfo } from './GiftInfo';
import { ShareGiftPage } from './ShareGiftPage';

const ImgAutoWidth = styled('img')(({ theme }) => ({
  height: theme.spacing(40.5),
  width: 'auto',
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}));

export type GiftProgressContainerProps = {
  plan?: VssPlan;
  account?: VssPublicAccount;
};

export const GiftProgressContainer: FC<GiftProgressContainerProps> = () => {
  const { plan, giftAndAccount } = useGiftStateContext();

  if (!giftAndAccount.data?.data?.accountPublic) {
    return <></>;
  }

  return (
    <Stack>
      <Card>
        <ImgAutoWidth
          alt=''
          src='/assets/images/illustrations/gift-with-circle.svg'
        />
        <GiftInfo
          accountPublic={giftAndAccount.data?.data?.accountPublic}
          plan={plan.data?.data}
        />
        {!giftAndAccount?.data?.data?.giftAccount?.hideGoal && (
          <ProgressChart
            data-testid='giftGoalProgress'
            decimals={1}
            description='Goal Progress'
            format='number'
            total={100}
            value={giftAndAccount?.data?.data?.giftAccount?.goalPercentage}
          />
        )}
      </Card>
      <ShareGiftPage mt={6} />
    </Stack>
  );
};
